// Zones, tarifs et délais de livraison : même fichier que le serveur
// (backend/static/shipping-countries.json, copié dans shippingCountries.json).
import config from './shippingCountries.json';
import { FREE_SHIPPING_THRESHOLD } from './shop';

export const SHIPPING_RATES = config.rates;
export const INTERNATIONAL_SHIPPING_RATE = config.rates.WORLD;
export const DEFAULT_COUNTRY = 'FR';

const BY_NAME = Object.fromEntries(Object.entries(config.names)
  .flatMap(([code, labels]) => Object.values(labels).map(name => [name.toLowerCase(), code])));

// Code ISO à 2 lettres ; accepte aussi un nom (« France », ancien format enregistré).
export function normalizeCountry(value) {
  const text = String(value || '').trim();
  if (config.names[text.toUpperCase()]) return text.toUpperCase();
  return BY_NAME[text.toLowerCase()] || DEFAULT_COUNTRY;
}

export const isServedCountry = code => Boolean(config.names[code]) && !config.blocked.includes(code);
export const requiresFrenchPostcode = code => config.domestic.includes(code);

export function zoneFor(code, postalCode = '') {
  // L'outre-mer français (codes postaux 97/98) part au tarif international ; Monaco reste au tarif France.
  if (code === 'MC' || (config.domestic.includes(code) && !/^9[78]/.test(String(postalCode).trim()))) return 'FR';
  return config.eu.includes(code) ? 'EU' : 'WORLD';
}

export function shippingCostFor(subtotal, code, postalCode = '') {
  if (subtotal <= 0 || subtotal >= FREE_SHIPPING_THRESHOLD) return 0;
  return config.rates[zoneFor(code, postalCode)];
}

export const deliveryDelay = (zone, locale = 'fr') => (config.delays[zone] || config.delays.FR)[locale] || config.delays.FR.fr;

export const countryName = (code, locale = 'fr') => config.names[code]?.[locale] || config.names[code]?.fr || code;

// Pays desservis (tous sauf « blocked »), France en tête puis ordre alphabétique de la langue affichée.
export function countryOptions(locale = 'fr') {
  const options = Object.keys(config.names).filter(isServedCountry)
    .map(code => ({ code, name: countryName(code, locale) }))
    .sort((a, b) => a.name.localeCompare(b.name, locale));
  const first = options.findIndex(option => option.code === DEFAULT_COUNTRY);
  return first > 0 ? [options[first], ...options.slice(0, first), ...options.slice(first + 1)] : options;
}
